/* ============================================================
   RA Quick Add — site-wide handler for the .ra-qa overlay.
   Lives once in theme.liquid; works for every card snippet that
   renders the .ra-qa markup (homepage grids, collection grid,
   PDP cross-sell, PDP "Pair It With").
   ============================================================ */
(function () {
  if (window.__raQuickAddV2) return;
  window.__raQuickAddV2 = true;

  function openCartDrawer() {
    /* Use the proper drawer API exposed by ra-cart-drawer-js.liquid.
       It internally re-fetches cart and re-renders items. */
    if (window.raCartDrawer && typeof window.raCartDrawer.open === 'function') {
      window.raCartDrawer.open();
      return;
    }
    /* Fallback: manually toggle classes if API not available yet */
    var drawer = document.querySelector('#ra-cart-drawer, .ra-drawer, cart-drawer');
    var overlay = document.querySelector('#ra-drawer-overlay, .ra-drawer-overlay');
    if (drawer) {
      drawer.classList.add('ra-drawer--open');
      drawer.classList.add('active');
    }
    if (overlay) {
      overlay.classList.add('ra-drawer-overlay--open');
    }
    document.body.style.overflow = 'hidden';
  }

  function refreshCartCount(count) {
    /* Cover every cart-count element used across header variants. The
       ra-header-upgrade snippet renders .ra-hdr-cartcount; older code
       used .ra-header__cart-count, .cart-count-bubble, [data-cart-count]. */
    var nodes = document.querySelectorAll(
      '.ra-hdr-cartcount, .ra-header__cart-count, .cart-count-bubble, .cart-count-bubble [aria-hidden="true"], [data-cart-count], .cart-count'
    );
    nodes.forEach(function (n) { n.textContent = count; });
    var bubble = document.querySelector('.cart-count-bubble');
    if (bubble) bubble.style.display = count > 0 ? '' : 'none';
  }

  function handlePill(pill, ev) {
    if (ev) { ev.preventDefault(); ev.stopPropagation(); }
    if (pill.classList.contains('ra-qa__pill--oos') || pill.disabled) return;
    var variantId = pill.getAttribute('data-variant-id');
    if (!variantId) return;
    var originalText = pill.textContent;
    pill.classList.add('ra-qa__pill--loading');
    pill.disabled = true;
    pill.textContent = '...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Add to cart failed');
        return r.json();
      })
      .then(function () {
        pill.classList.remove('ra-qa__pill--loading');
        pill.classList.add('ra-qa__pill--added');
        pill.textContent = '✓';
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        refreshCartCount(cart.item_count);
        /* Notify the drawer so it re-fetches + re-renders items.
           ra-cart-drawer-js listens for 'ra:cart:added'. */
        document.dispatchEvent(new CustomEvent('ra:cart:added', { detail: { cart: cart } }));
        setTimeout(function () {
          openCartDrawer();
          pill.classList.remove('ra-qa__pill--added');
          pill.textContent = originalText;
          pill.disabled = false;
        }, 350);
      })
      .catch(function (err) {
        console.error('[RA Quick Add]', err);
        pill.classList.remove('ra-qa__pill--loading');
        pill.textContent = originalText;
        pill.disabled = false;
      });
  }

  /* Event delegation — works for cards rendered later via JS */
  document.addEventListener('click', function (ev) {
    var pill = ev.target.closest('.ra-qa__pill');
    if (pill) handlePill(pill, ev);
  });
})();
